import * as React from 'react';
import { LocalizedComponentProps } from 'bernie-l10n';
import { NewDateField } from './new-date-field';

export interface DateRangeState {
  endDateFocus?: () => void;
  startDateFocus?: () => void;
}

export type LocalizedDateRateProps = LocalizedComponentProps;

export interface DateRangeProps extends LocalizedDateRateProps {
  fetchDatePickerRates?: () => Promise<object>;
}

export class DateRange extends React.Component<DateRangeProps, DateRangeState> {
  constructor(props) {
    super(props);

    this.state = {
      endDateFocus: undefined,
      startDateFocus: undefined,
    };

    this.handleChange = this.handleChange.bind(this);
    this.registerFocusMethod = this.registerFocusMethod.bind(this);
  }

  private handleChange(startDate: Date, endDate: Date) {
    //TODO
  }

  public render() {
    const startDate = new Date().toISOString().split('T')[0];
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const endDate = tomorrow.toISOString().split('T')[0];
    const buttonText = 'submit text';
    const wrapperClasses = 'uitk-grid uitk-cell s-cell-1-1 m-cell-1-3 l-cell-1-6 xl-cell-1-6';

    const commonDateFieldProps = {
      startDate,
      endDate,
      onChange: this.handleChange,
      buttonText,
      registerFocusMethod: this.registerFocusMethod,
    };

    const routerLinkWrapper = (children) => <>{children}</>;

    const dateFieldProps = {
      dateFieldWrapperClasses: wrapperClasses,
      endId: 'hotels-check-out',
      endLabel: 'Checkout-Date',
      endName: 'endDate',
      onChange: commonDateFieldProps.onChange,
      routerLinkWrapper,
      startId: 'hotels-check-in',
      startLabel: 'checkin-date',
      startName: 'startDate',
    };

    const rfrr = {
      end: ':ChangeDatesCheckOut',
      start: ':ChangeDatesCheckIn',
    };

    return <NewDateField rfrr={rfrr} dateFieldProps={dateFieldProps} {...commonDateFieldProps} />;
  }

  private registerFocusMethod(fieldName: string, focusMethod: () => void) {
    this.setState({ [`${fieldName}Focus`]: focusMethod });
  }
}
